import * as React from "react";

import { IconButton, Menu, MenuItem } from "@mui/material";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { Person } from "@mui/icons-material";

export default function UserNav(props) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const devToolAccess = sessionStorage.getItem("devtools");
  const isDevPanelEnabled = process.env.REACT_APP_IS_DEVPANEL_ENABLED;

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("videostory");
    sessionStorage.removeItem("storyline");
    sessionStorage.removeItem("devtools");
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();

    // navigate("/user/login");
    setAnchorEl(null);
  };

  const handleDevPanel = () => {
    console.log("Dev Panel");
    props.openDevPanel(true);
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        sx={{
          borderRadius: "8px",
          border: "1px solid #A9A3C233",
          background: theme.palette.primary.dark,
          color: theme.palette.primary.white,
        }}
        onClick={handleMenu}
      >
        <Person />
        {/* <AccountCircle /> */}
      </IconButton>
      <Menu
        elevation={0}
        sx={{
          mt: "55px",
          background: "none transparent",
          "& .MuiPaper-root": {
            backgroundColor: "transparent",
          },
        }}
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* <MenuItem key="profile" onClick={handleClose}><AccountBoxOutlinedIcon style={{marginRight: 12}}/>Profile</MenuItem> */}
        {/* {devToolAccess == "true" && (
          <MenuItem
            key="settings"
            onClick={handleDevPanel}
            sx={{
              background:
                sessionStorage.getItem("mode") === "light"
                  ? "#EEF7FF"
                  : "none transparent",
              borderRadius: 60,
              border: "1px solid",
              fontSize: 14,
              marginBottom: 1,
              transition: "all ease-in 0.2s",
              "&:hover": {
                background: "#AC1FFF",
                color: "#ffffff",
                borderColor: "#AC1FFF",
              },
            }}
          >
            <SettingsOutlinedIcon style={{ fontSize: 18, marginRight: 12 }} />
            Dev Panel
          </MenuItem>
        )} */}
        <MenuItem
          key="logout"
          onClick={handleLogout}
          sx={{
            background:
              sessionStorage.getItem("mode") === "light"
                ? "#EEF7FF"
                : "none transparent",
            borderRadius: 60,
            border: "1px solid",
            fontSize: 14,
            transition: "all ease-in 0.2s",
            "&:hover": {
              background: "#AC1FFF",
              color: "#ffffff",
              borderColor: "#AC1FFF",
            },
          }}
        >
          <ExitToAppIcon style={{ fontSize: 18, marginRight: 12 }} />
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
}
